class ProductSizeHandler {
  constructor(wrapper) {
    if (!wrapper) return;
    if (wrapper.dataset.init) return;

    this.wrapper = wrapper;
    this.productId = wrapper.dataset.productId;
    this.sizeItems = wrapper.querySelectorAll('.size-item.size-available');

    this.bindEvents();
    wrapper.dataset.init = '1';
  }

  bindEvents() {
    this.sizeItems.forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault();
        if (item.classList.contains('loading')) return;
        this.handleClick(item);
      });
    });
  }

  handleClick(item) {
    const variantId = item.dataset.variantId;
    if (!variantId) return;

    item.classList.add('loading');

    this.addToCart({
      id: variantId,
      size: item.dataset.size,
      title: item.dataset.productTitle,
      comparePrice: item.dataset.lineitemCompareat,
      el: item
    });
  }

  async addToCart({ id, size, title, comparePrice, el }) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id,
            quantity: 1,
            properties: {
              Size: size,
              Product: title,
              'Compare at price': comparePrice
            }
          }]
        })
      });

      if (!res.ok) throw new Error('Add to cart failed');

      await res.json();
      el.classList.remove('loading');
      window.location.href = '/cart';

    } catch (err) {
      console.error(err);
      el.classList.remove('loading');
      this.showError('Failed to add to cart');
    }
  }

  showError(msg) {
    const toast = document.createElement('div');
    toast.textContent = msg;
    toast.style.cssText = `
      position:fixed;
      top:20px;
      right:20px;
      background:#e53935;
      color:#fff;
      padding:12px 18px;
      border-radius:4px;
      z-index:9999;
      font-size:14px;
    `;
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  }
}

function initProductSizes(root = document) {
  if (!(root instanceof Element || root instanceof Document)) return;

  const wrappers = root.querySelectorAll('.product-sizes-wrapper');
  wrappers.forEach(wrapper => new ProductSizeHandler(wrapper));
}

document.addEventListener('DOMContentLoaded', () => {
  initProductSizes(document);
});

new MutationObserver(mutations => {
  mutations.forEach(m => {
    m.addedNodes.forEach(node => {
      if (!(node instanceof Element)) return;

      if (
        node.matches('.product-sizes-wrapper') ||
        node.querySelector('.product-sizes-wrapper')
      ) {
        initProductSizes(node);
      }
    });
  });
}).observe(document.body, { childList: true, subtree: true });
